@import '../../../globals/main.scss';

pn-profile-modal {
  margin: 1em auto;
  display: flex;
  flex-direction: column;
  min-width: 42.4rem;
  max-width: 38.4rem;
  width: 100%;
  padding: 1.6rem;
  border-radius: 8px;
  background: $white;
}

.profilemodal-container {
  padding: 3.2rem;
  border-radius: 8px;
  box-shadow:
    0 0.06rem 0.18rem rgba(0, 0, 0, 0.1),
    0 0.32rem 0.72rem rgba(0, 0, 0, 0.13);
  border: 0.1rem solid $gray50;
  display: flex;
  flex-direction: column;
}

.profilemodal-logo {
  display: none;
  svg {
    display: block;
    margin: 0 auto 2.4rem;
  }
}

.profilemodal-heading {
  text-align: center;
  font-weight: 700;
}

.profilemodal-content {
  margin: 1.6rem 0 0;
  pn-segmented-control {
    transform: translateZ(0) translateX(-50%);
    left: 50%;
  }
}

.profilemodal-cta {
  margin: 1.6rem 0 0;
  transition:
    max-height 0.15s ease,
    opacity 0.15s ease;
  overflow: hidden;
  opacity: 1;
  &[aria-hidden='true'] {
    max-height: 0;
    opacity: 1;
  }
  > pn-button {
    width: 100%;
  }
}
